import { Tarifart } from '@/types/Tarifart';
import { Teilimpfungsart } from '@/types/Teilimpfungsart';

export default class Belegposition {
    /** PK: Belegosition | erforderlich */
    public belegposition_id: number | null = null;
    /** FK: Beleg | erforderlich */
    public beleg_id: number | null = null;
    /** Positionsnummer | erforderlich */
    public posnr: number | null = null;
    /** Anzahl | erforderlich */
    public anzahl: number | null = null;
    /** Code der Impfung aus Altsystem | max. 8 Zeichen */
    public impfung_code: string | null = null;
    /** Bezeichnung der Impfung aus Altsystem | max. 50 Zeichen */
    public impfung: string | null = null;
    /** FK: Impfstoff */
    public impfstoff_id: number | null = null;
    /** Nummer der Teilimpfung */
    public teilimpfungsnr: number | null = null;
    /** FK: Leistung */
    public leistung_id: number | null = null;
    /** FK: PatUntersuchung */
    public untersuchung_id: number | null = null;
    /** Tarifart | max. 1 Zeichen | erforderlich */
    public tarifart: string | null = Tarifart.Normal;
    /** Einkaufspreis */
    public einkaufspreis: number | null = null;
    /** Einzelpreis Netto */
    public verkaufspreis: number | null = null;
    /** Einzelpreis Brutto */
    public verkaufspreis_brutto: number | null = null;
    /** Betrag Netto | erforderlich */
    public betrag: number | null = null;
    /** Betrag Brutto */
    public betrag_brutto: number | null = null;
    /** MwSt.-Satz **/
    public steuersatz: number | null = null;
    /** Betrag der MWSt. **/
    public steuer: number | null = null;
    /** Erlöskonto | max. 10 Zeichen **/
    public konto: string | null = null;
    /** Durchführende Arzt */
    public person_id: number | null = null;

    public impfstoff_impfung: string | null = null;
    public impfstoff_impfstoff: string | null = null;
    public impfstoff_verkaufspreis: number | null = null;
    public impfstoff_bezeichnung: string | null = null;
    public leistung_leistung: string | null = null;
    public leistung_bezeichnung: string | null = null;
    public leistung_preis: number | null = null;
    public untersuchung_untersuchung: string | null = null;
    public untersuchung_preis: number | null = null;
    public impfdosis_teilimpfung: string | null = null;
    public beleg_storniert: string | null = null;

    public patuntersuchung_id: number | null = null;
    public originalpreis: number | null = null;
    public patientengruppe_id: number | null = null;

    public temp_verkaufspreis: number | null = 0;

    public get impfungsText(): string {
        if (this.impfstoff_id) {
            return `${this.impfstoff_impfung} (${this.impfstoff_bezeichnung})`;
        }

        if (this.impfung) {
            return this.impfung;
        }

        return '';
    }

    public get teilimpfungsKuerzel(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'A. ';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. ';
            }
        }

        return '';
    }

    public get teilimpfungsText(): string {
        if (this.teilimpfungsnr !== null) {
            if (this.isAuffrischung) {
                return 'Auffrischung';
            }

            if (this.isTeilimpfung) {
                return this.teilimpfungsnr + '. Teilimpfung';
            }
        }

        return '';
    }

    public get isImpfung(): boolean {
        return this.impfstoff_id !== null || this.impfung !== null;
    }

    public get isEinfachimpfung(): boolean {
        return this.teilimpfungsnr === Teilimpfungsart.Einfachimpfung;
    }

    public get isTeilimpfung(): boolean {
        return this.impfdosis_teilimpfung === 'j';
    }

    public get isAuffrischung(): boolean {
        return !this.isEinfachimpfung && !this.isTeilimpfung;
    }

    public get isLeistung(): boolean {
        return this.leistung_id !== null;
    }

    public get isUntersuchung(): boolean {
        return this.untersuchung_id !== null;
    }

    public get isStorniert(): boolean {
        return this.beleg_storniert === 'j';
    }

    public get isRabatt(): boolean {
        return this.tarifart === Tarifart.Rabatt5 ||
            this.tarifart === Tarifart.Rabatt10 ||
            this.tarifart === Tarifart.Rabatt15 ||
            this.tarifart === Tarifart.Rabatt20 ||
            this.tarifart === Tarifart.Rabatt30;
    }

    public get tarifartText(): string {
        switch (this.tarifart) {
            case Tarifart.Normal:
                return 'Normaltarif';
            case Tarifart.Halb:
                return 'halber Tarif';
            case Tarifart.Individuell:
                return 'Individualtarif';
            case Tarifart.KeineVerrechnung:
                return 'keine Verrechnung';
            case Tarifart.Spaeter:
                return 'später verrechnen';
            case Tarifart.Rabatt5:
                return '5% Rabatt';
            case Tarifart.Rabatt10:
                return '10% Rabatt';
            case Tarifart.Rabatt15:
                return '15% Rabatt';
            case Tarifart.Rabatt20:
                return '20% Rabatt';
            case Tarifart.Rabatt30:
                return '30% Rabatt';
            default:
                return '';
        }
    }

    constructor(data?: Partial<Belegposition>) {
        Object.assign(this, data);
    }
}
